import { render, staticRenderFns } from "./ConfirmPopup.vue?vue&type=template&id=2e131f56&scoped=true&"
import script from "./ConfirmPopup.vue?vue&type=script&lang=ts&"
export * from "./ConfirmPopup.vue?vue&type=script&lang=ts&"
import style0 from "./ConfirmPopup.vue?vue&type=style&index=0&id=2e131f56&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e131f56",
  null
  
)

export default component.exports